import { Media } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { ClippedImage } from '@components/ClippedImage/ClippedImage.component';
import { Text } from '@components/Text/Text.component';
import { ClippedImageStyle } from '@utils/images';
import classNames from 'classnames';

import styles from './InnovationDetailConcept.module.scss';

type Props = ComponentPropsWithRef<'main'> & {
  firstdescriptionquote: string;
  firstimagequote: Media;
  firstquote: string;
  quote: string;
  seconddescriptionquote: string;
  secondimagequote?: Media;
  secondquote: string;
  thirddescriptionquote: string;
  thirdimagequote?: Media;
  thirdquote: string;
};

export const InnovationDetailConcept: FC<Props> = ({
  className,
  firstdescriptionquote,
  firstimagequote,
  firstquote,
  quote,
  seconddescriptionquote,
  secondimagequote,
  secondquote,
  thirddescriptionquote,
  thirdimagequote,
  thirdquote,
}) => {
  const rootClass = classNames(className);

  const displayBloc2 = secondquote && seconddescriptionquote && secondimagequote;
  const displayBloc3 = thirdquote && thirddescriptionquote && thirdimagequote;

  return (
    <div className={rootClass}>
      <div className="wrapper-s plc-pb-s">
        <div className={styles["grid-parent-bloc-debut"]}>
          <Text className={styles["bold"]} tag="p" variant="h3">
            {quote && quote.length > 0 ? quote : '\u00A0'}
            {/* FYI \u00A0 <=> &nbsp */}
          </Text>
        </div>
        <div className={`${styles['grid-parent-bloc-1']} plc-my-l`}>
          <div className={styles["grid-bloc-1-image"]}>
            <ClippedImage
              alt={firstimagequote.alt ?? ''}
              caption={firstimagequote?.alt ?? ''}
              clipStyle={ClippedImageStyle.innovationConceptBloc1}
              plcSrc={{ src: firstimagequote.url, type: 'external' }}
            />
          </div>
          <div className={styles["grid-bloc-1-texte"]}>
            <Text className="h2-up-s plc-mb-m" i18nKey="innovations.detail.concept" tag="h2" variant="h3" />
            <Text className={`${styles['bold']} ${styles['x-large']} plc-mb-s`} tag="p" variant="small">
              {firstquote}
            </Text>
            <Text className="pre-line" tag="p" variant="p">
              {firstdescriptionquote}
            </Text>
          </div>
        </div>
        {displayBloc2 && secondimagequote && (
          <div className={`${styles['grid-parent-bloc-2']} plc-my-l`}>
            <div className={styles["grid-bloc-2-texte"]}>
              <Text className={`${styles['bold']} ${styles['x-large']} plc-mb-s`} tag="p" variant="small">
                {secondquote}
              </Text>
              <Text className="pre-line" tag="p" variant="p">
                {seconddescriptionquote}
              </Text>
            </div>
            <div className={styles["grid-bloc-2-image"]}>
              <ClippedImage
                alt={secondimagequote && secondimagequote.alt ? secondimagequote.alt : ''}
                caption={secondimagequote && secondimagequote.alt ? secondimagequote.alt : ''}
                clipStyle={ClippedImageStyle.innovationConceptBloc2}
                plcSrc={{ src: secondimagequote.url, type: 'external' }}
              />
            </div>
          </div>
        )}
        {displayBloc3 && thirdimagequote && (
          <div className={`${styles['grid-parent-bloc-3']} plc-my-l`}>
            <div className={styles["grid-bloc-3-image"]}>
              <ClippedImage
                alt={thirdimagequote && thirdimagequote.alt ? thirdimagequote.alt : ''}
                caption={thirdimagequote && thirdimagequote.alt ? thirdimagequote.alt : ''}
                clipStyle={ClippedImageStyle.innovationConceptBloc3}
                plcSrc={{ src: thirdimagequote.url, type: 'external' }}
              />
            </div>
            <div className={styles["grid-bloc-3-texte"]}>
              <Text className={`${styles['bold']} ${styles['x-large']} plc-mb-s`} tag="p" variant="small">
                {thirdquote}
              </Text>
              <Text className="pre-line" tag="p" variant="p">
                {thirddescriptionquote}
              </Text>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
